/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const setPaymentMethodNicknameDataSchema = z.object({
	nickname: z.string().nullable().optional(),
})

export type SetPaymentMethodNicknameDataSchema = z.infer<typeof setPaymentMethodNicknameDataSchema>
